import React from "react";
import { EmptyState } from "../../../../ForBrands/ui/BrandUI";
import CollapsibleCard from "../../../../ForBrands/ui/CollapsibleCard";
import { LegendRow } from "../../../../ForBrands/ui/LegendItem";
import ColumnPair from "../../../../ForBrands/ui/charts/ColumnPair";
import { ROLE } from "../../../../ForBrands/ui/charts/chartTokens";
import { positionView } from "../teamPerformanceModel";

// Position Depth (G / F / C) (BUILD_SPEC B7, Jayson's T10): three columns,
// each pairing the squad's share of minutes (bm-orange) with the peer
// average (grey), the rotation head count against the peers' under it,
// and a critical border plus the word "missing" or "thin" when a makeup
// read flags the position. Three columns on phones too. With no positions
// on file the card says so in the tab's empty state (no legend).

const LEGEND = [
  { key: "squad", swatch: "bar", color: ROLE.self, label: "Squad" },
  { key: "peers", swatch: "bar", color: ROLE.peer, label: "Peer average" },
];

const PositionDepthCard = ({ makeup, collapse }) => {
  const { columns, scale, caption } = positionView(makeup);
  return (
    <CollapsibleCard title="Position Depth (G / F / C)" titleAs="h3" subtitle={caption} {...collapse}>
      {columns.length ? (
        <>
          <LegendRow items={LEGEND} label="Position depth legend" />
          <div className="grid grid-cols-3 gap-2 sm:gap-3">
            {columns.map((c) => (
              <ColumnPair
                key={c.key}
                label={c.label}
                code={c.code}
                bars={[
                  { key: "squad", label: "Squad", value: c.team, color: ROLE.self },
                  { key: "peers", label: "Peer average", value: c.peers, color: ROLE.peer },
                ]}
                scale={scale}
                footer={c.footer}
                alert={c.alert}
              />
            ))}
          </div>
        </>
      ) : (
        <EmptyState>No positions on file for this squad.</EmptyState>
      )}
    </CollapsibleCard>
  );
};

export default PositionDepthCard;
